import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Comedian from "../views/Comedian.vue";
import Actor from "../views/Actor.vue";
import PDFs from "../views/PDFs.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/comedian",
    name: "comedian",
    component: Comedian,
  },
  {
    path: "/actor",
    name: "actor",
    component: Actor,
  },
  {
    path: "/pdfs",
    name: "pdfs",
    component: PDFs,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
